export interface TicketTemplate {
    recID: number;
    name: string;
    templateText: string;
}

export enum TokenType {
    TextLiteral,
    Variable,
    Command
}

export interface Token {
    hexCode: string;
    tokenType: TokenType;
}

export interface VariableToken extends Token {
    variableName: Variables;
}

export interface TextLiteralToken extends Token {
    contents: string;
}

export interface CommandToken extends Token {
    commandType: CommandType;
    prefix: string;
}

export enum Variables {
    ViolationDescription,
    IssueDate,
    IssueTime,
    IssueDateTime,
    PlateNumber,
    PlateState,
    VehicleMake,
    VehicleColor,
    OfficerName,
    Comment,
    CitationNumber,
    Location,
    BadgeNumber,
    PlateExpiration,
    VehicleModel,
    LotName,
    FineAmount,
    TaxAmount,
    TotalAmount,
    EscalatedAmount,
    SecondEscalatedAmount,
    PlateType,
    VehicleBodyType,
    Meter,
    EscalationAmount,
    SecondEscalationAmount,
    VehicleYear,
    VehicleVIN,
    ViolationCode,
    ChalkDate,
    ChalkTime,
    Signature,
    Barcode,
    TopBarcode,
    BlockNumber,
    HearingDate,
    PlateColor,
    VehicleMakeDescription,
    VehicleColorDescription,
    ViolationType,
    ViolationSuffix,
    IssueingAgent,
    FeeDescription,
}

export enum CommandType {
    SetFontSize,
    SetHorizontalAlignment,
    SetLeftMargin,
    SetRightMargin,
    SetTabs,
    MoveToTab,
    ClearTabs,
    SetLineFeedSize,
    FeedSingleLine,
    FeedMultipleLines,
    FeedAmount,
    ScrollToTicketEnd,
    SetPageLength,
    StartEmphasis,
    CancelEmphasis,
    StartUnderline,
    CancelUnderline,
    Image,
}
